import React from 'react';
import { CreditCard } from 'lucide-react';
import { Badge } from '../ui/badge';

const getMembershipBadge = (status) => {
  switch (status) {
    case 'active':
      return <Badge className="badge-active">Active</Badge>;
    case 'inactive':
      return <Badge className="badge-inactive">Inactive</Badge>;
    case 'expiring_soon':
      return <Badge className="badge-expiring">Expiring Soon</Badge>;
    default:
      return <Badge>{status}</Badge>;
  }
};

const MembershipStatusCard = ({ membershipStatus }) => {
  return (
    <div className="mb-6">
      <div className="card border-2 border-cyan-200 bg-gradient-to-br from-white to-cyan-50 shadow-lg">
        <h2 className="text-xl font-semibold text-slate-900 mb-4 pb-2 border-b-2 border-cyan-100 flex items-center gap-2">
          <CreditCard size={20} className="text-cyan-600" />
          Membership Status
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Status</p>
            {getMembershipBadge(membershipStatus.status)}
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Start Date</p>
            <p className="text-slate-900">{membershipStatus.start_date}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Expiry Date</p>
            <p className="text-slate-900">{membershipStatus.expiry_date}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Onboarding</p>
            <p className="text-slate-900 capitalize">{membershipStatus.onboarding_status}</p>
          </div>
          <div>
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Health Interview</p>
            <p className="text-slate-900 capitalize">{membershipStatus.health_interview_status}</p>
          </div>
          {membershipStatus.health_interview_date && (
            <div>
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">First Encounter</p>
              <p className="text-slate-900">{membershipStatus.health_interview_date}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MembershipStatusCard;
